import { useMutation } from '@tanstack/react-query';

import { Site } from 'src/features/sites/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site/`;

interface DTO {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({parkingId, ...data}: DTO): Promise<Site> => {
    return axios.post(formatResourcePath(RESOURCE, {parkingId}), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSite };
